import React, { Component } from 'react';
import { getCookie, onChange } from '../../utils';
import constant from '../../constant';
import NumberFormat from 'react-number-format';
import { Typeahead } from 'react-bootstrap-typeahead';
import { updateHrDealingOfficer, updateMedicalReport } from '../../actions/UserAction';
import { setOptions } from '../../utils';
import { getStorage } from '../../utils';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { ToastContainer, toast } from 'react-toastify';
import { validateForm } from '../../utils';
import Form from 'react-bootstrap/Form'
import { withRouter } from "react-router-dom";


class CommentModel extends Component {

    constructor(props) {
        super(props)


        this.state = {
            ud: getCookie(constant.cookie.userDetail),
            hrDealing: getStorage(constant.cookie.hrDealingOfficerList)[0],
            hrExecutive: getStorage(constant.cookie.hrexecutive)[0],
            finance: getStorage(constant.cookie.finance),
            patientNames: { name: 'patientNames', value: ["Testing name "], error: '', isRequired: false, options: [], },
            bankAccount: { name: 'bankAccount', value: '', error: '', isRequired: false, },
            bankName: { name: 'bankName', value: '', error: '', isRequired: false, },
            ifsc: { name: 'ifsc', value: '', error: '', isRequired: false, },

            consultationCharges: { name: 'consultationCharges', value: '', options: [], error: '', isRequired: true, },
            consultationChargesFiles: { name: 'consultationChargesFiles', value: '', options: '', error: '', isRequired: false, },

            medicineCost: { name: 'medicineCost', value: '', options: [], error: '', isRequired: true, },
            medicineCostFiles: { name: 'medicineCostFiles', value: '', options: [], error: '', isRequired: false, },

            pathologicalCharges: { name: 'pathologicalCharges', value: '', options: [], error: '', isRequired: true, },
            pathologicalChargesFiles: { name: 'pathologicalChargesFiles', value: '', options: [], error: '', isRequired: false, },

            physiothrapyCharges: { name: 'physiothrapyCharges', value: '', options: [], error: '', isRequired: true, },
            physiothrapyChargesFiles: { name: 'physiothrapyChargesFiles', value: '', options: [], error: '', isRequired: false, },

            operationCharges: { name: 'operationCharges', value: '', options: [], error: '', isRequired: true, },
            operationChargesFiles: { name: 'operationChargesFiles', value: '', options: [], error: '', isRequired: false, },

            operationTheatreCharges: { name: 'operationTheatreCharges', value: '', options: [], error: '', isRequired: true, },
            operationTheatreChargesFiles: { name: 'operationTheatreChargesFiles', value: '', options: [], error: '', isRequired: false, },

            anaesthesiaCharges: { name: 'anaesthesiaCharges', value: '', options: [], error: '', isRequired: true, },
            anaesthesiaChargesFiles: { name: 'anaesthesiaChargesFiles', value: '', options: [], error: '', isRequired: false, },

            roomIcuCharges: { name: 'roomIcuCharges', value: '', options: [], error: '', isRequired: true, },
            roomIcuChargesFiles: { name: 'roomIcuChargesFiles', value: '', options: [], error: '', isRequired: false, },

            injectionCharges: { name: 'injectionCharges', value: '', options: [], error: '', isRequired: true, },
            injectionChargesFiles: { name: 'injectionChargesFiles', value: '', options: [], error: '', isRequired: false, },

            disposalCharges: { name: 'disposalCharges', value: '', options: [], error: '', isRequired: true, },
            disposalChargesFiles: { name: 'disposalChargesFiles', value: '', options: [], error: '', isRequired: false, },

            dentalCharges: { name: 'dentalCharges', value: '', options: [], error: '', isRequired: true, },
            dentalChargesFiles: { name: 'dentalChargesFiles', value: '', options: [], error: '', isRequired: false, },

            otherCharges: { name: 'otherCharges', value: '', options: [], error: '', isRequired: true, },
            otherChargesFiles: { name: 'otherChargesFiles', value: '', options: [], error: '', isRequired: false, },

            executiveHr: { name: 'executiveHr', value: '', options: [], error: '', isRequired: false, },
            description: { name: 'description', value: '', error: '', isRequired: true, },

            totalSum: { name: 'totalSum', value: 0, options: [], error: '', isRequired: false, },

        }

    }


    componentDidMount() {


        updateHrDealingOfficer().then((res) => {
            if (res.status === constant.static.apiStatus.success) {
                setOptions(this, this.state.executiveHr.name, getStorage(constant.cookie.hrexecutive))
                onChange(this, this.state.description.name, this.props.list.length > 0 ? this.props.list[0].description : "")
            } else {
                alert(res.error);
            }
        })

    }


    onSameCheck = (e) => {
        const { list } = this.props


        if (e.target.name == this.state.consultationCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.consultationCharges.name, ele.consultationCharges))
            } else {
                list.find((ele) => onChange(this, this.state.consultationCharges.name, ""))
            }
        }


        if (e.target.name == this.state.medicineCost.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.medicineCost.name, ele.medicineCost))
            }
            else {
                list.find((ele) => onChange(this, this.state.medicineCost.name, ""))
            }
        }


        if (e.target.name == this.state.pathologicalCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.pathologicalCharges.name, ele.pathologicalCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.pathologicalCharges.name, ""))
            }
        }


        if (e.target.name == this.state.physiothrapyCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.physiothrapyCharges.name, ele.physiothrapyCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.physiothrapyCharges.name, ""))
            }
        }

        if (e.target.name == this.state.operationCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.operationCharges.name, ele.operationCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.operationCharges.name, ""))
            }
        }

        if (e.target.name == this.state.operationTheatreCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.operationTheatreCharges.name, ele.operationTheatreCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.operationTheatreCharges.name, ""))
            }
        }

        if (e.target.name == this.state.anaesthesiaCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.anaesthesiaCharges.name, ele.anaesthesiaCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.anaesthesiaCharges.name, ""))
            }
        }

        if (e.target.name == this.state.roomIcuCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.roomIcuCharges.name, ele.roomIcuCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.roomIcuCharges.name, ""))
            }
        }

        if (e.target.name == this.state.injectionCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.injectionCharges.name, ele.injectionCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.injectionCharges.name, ""))
            }

        }

        if (e.target.name == this.state.disposalCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.disposalCharges.name, ele.disposalCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.disposalCharges.name, ""))
            }
        }

        if (e.target.name == this.state.dentalCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.dentalCharges.name, ele.dentalCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.dentalCharges.name, ""))
            }
        }

        if (e.target.name == this.state.otherCharges.name) {
            if (e.target.checked == true) {
                list.find((ele) => onChange(this, this.state.otherCharges.name, ele.otherCharges))
            }
            else {
                list.find((ele) => onChange(this, this.state.otherCharges.name, ""))
            }
        }




    }

    typeaheadOnChange = (name, e) => {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }


    render() {
        const { list } = this.props
        const { executiveHr, finance } = this.state
        return (

            <React.Fragment>

                {list && list.length > 0 ?
                    <React.Fragment>
                        { /* Consulatation charges */}

                        <label> <strong>  Bank credentials   </strong></label>
                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].accountNumber}
                                    disabled={true}
                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].bankName}
                                    disabled={true}
                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].ifscCode}
                                    disabled={true}
                                />
                            </div>

                        </div>



                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Consulatation charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].consultationCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className=" col-4 col-md-4 my-2 ">

                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.consultationCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.consultationCharges.name}
                                                    value={this.state.consultationCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.consultationCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.consultationCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.consultationCharges.name}
                                            value={this.state.consultationCharges.value}
                                            onChange={this.onChange}
                                        />
                                }


                            </div>

                        </div>

                        { /* Consulatation charges */}




                        <div className="row">

                            <div className="col-4 col-md-4 my-2">
                                <label>  Medicine Cost   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].medicineCost}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.medicineCost.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.medicineCost.name}
                                                    value={this.state.medicineCost.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.medicineCost.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.medicineCost.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.medicineCost.name}
                                            value={this.state.medicineCost.value}
                                            onChange={this.onChange}
                                        />
                                }
                            </div>

                        </div>









                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Pathological Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].pathologicalCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">

                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.pathologicalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.pathologicalCharges.name}
                                                    value={this.state.pathologicalCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.pathologicalCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.pathologicalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.pathologicalCharges.name}
                                            value={this.state.pathologicalCharges.value}
                                            onChange={this.onChange}
                                        />
                                }
                            </div>

                        </div>










                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Physiothrapy Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].physiothrapyCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.physiothrapyCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.physiothrapyCharges.name}
                                                    value={this.state.physiothrapyCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.physiothrapyCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.physiothrapyCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.physiothrapyCharges.name}
                                            value={this.state.physiothrapyCharges.value}
                                            onChange={this.onChange}
                                        />
                                }
                            </div>

                        </div>








                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Operation Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].operationCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">

                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.operationCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.operationCharges.name}
                                                    value={this.state.operationCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.operationCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.operationCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.operationCharges.name}
                                            value={this.state.operationCharges.value}
                                            onChange={this.onChange}
                                        />
                                }

                            </div>

                        </div>









                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  OperationTheatre Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].operationTheatreCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.operationTheatreCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.operationTheatreCharges.name}
                                                    value={this.state.operationTheatreCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.operationTheatreCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.operationTheatreCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.operationTheatreCharges.name}
                                            value={this.state.operationTheatreCharges.value}
                                            onChange={this.onChange}
                                        />
                                }
                            </div>

                        </div>








                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Anaesthesia Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].anaesthesiaCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">


                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.anaesthesiaCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.anaesthesiaCharges.name}
                                                    value={this.state.anaesthesiaCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.anaesthesiaCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.anaesthesiaCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.anaesthesiaCharges.name}
                                            value={this.state.anaesthesiaCharges.value}
                                            onChange={this.onChange}
                                        />
                                }



                            </div>

                        </div>




                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Room/ICU Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].roomIcuCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">

                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.roomIcuCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.roomIcuCharges.name}
                                                    value={this.state.roomIcuCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.roomIcuCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.roomIcuCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.roomIcuCharges.name}
                                            value={this.state.roomIcuCharges.value}
                                            onChange={this.onChange}
                                        />
                                }

                            </div>

                        </div>







                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>   Injection Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].injectionCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">


                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.injectionCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.injectionCharges.name}
                                                    value={this.state.injectionCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.injectionCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.injectionCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.injectionCharges.name}
                                            value={this.state.injectionCharges.value}
                                            onChange={this.onChange}
                                        />
                                }

                            </div>

                        </div>





                        <div className="row">
                            <div className="col-4 col-md-4 my-2 ">
                                <label>  Disposal Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].disposalCharges}
                                    disabled={true}
                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">

                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.disposalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.disposalCharges.name}
                                                    value={this.state.disposalCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.disposalCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>
                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.disposalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.disposalCharges.name}
                                            value={this.state.disposalCharges.value}
                                            onChange={this.onChange}
                                        />
                                }

                            </div>

                        </div>



                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Dental Charges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].dentalCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.dentalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.dentalCharges.name}
                                                    value={this.state.dentalCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.dentalCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.dentalCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.dentalCharges.name}
                                            value={this.state.dentalCharges.value}
                                            onChange={this.onChange}
                                        />
                                }


                            </div>

                        </div>






                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  OtherCharges   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].otherCharges}
                                    disabled={true}

                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">



                                {
                                    this.state.ud.code == this.state.hrExecutive.code ?
                                        <div className="row">
                                            <div className='col-8 col-md-8 '>
                                                <NumberFormat
                                                    prefix={constant.static.currencySymbol}
                                                    className={this.state.otherCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    placeholder=""
                                                    name={this.state.otherCharges.name}
                                                    value={this.state.otherCharges.value}
                                                    onChange={this.onChange}
                                                />
                                            </div>

                                            <div className='col-4 col-md-4' >
                                                <Form >
                                                    <Form.Check
                                                        name={this.state.otherCharges.name}
                                                        onClick={e => this.onSameCheck(e)}
                                                        type="switch"
                                                        id="custom-switch"
                                                        label="Check"

                                                    />
                                                </Form>
                                            </div>

                                        </div> :
                                        <NumberFormat
                                            prefix={constant.static.currencySymbol}
                                            className={this.state.otherCharges.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={this.state.otherCharges.name}
                                            value={this.state.otherCharges.value}
                                            onChange={this.onChange}
                                        />
                                }



                            </div>

                        </div>







                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Total   </label>
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder=""
                                    value={list[0].totalSum}
                                    disabled={true}
                                    multiple={true}
                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">
                                <NumberFormat
                                    prefix={constant.static.currencySymbol}
                                    className={this.state.totalSum.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                    placeholder=""
                                    name={this.state.totalSum.name}
                                    // value={this.state.injectionChargesFiles.value}
                                    // onChange={this.onChange}
                                    multiple={true}
                                />
                            </div>

                        </div>



                        <div className="row">

                            {
                                this.state.ud.code == this.state.hrExecutive.code ?
                                    <React.Fragment>
                                        <div className="col-6 col-md-4 my-2">
                                            <label>  Send to   </label>
                                        </div>


                                        <div className="col-6 col-md-8 my-2">
                                            <Typeahead
                                                id="ta-recipient"

                                                labelKey={(option) => `${option.name} - ${option.employeeNumber}`}
                                                name={executiveHr.name}
                                                value={executiveHr.value}
                                                multiple={false}
                                                options={finance.filter(item => item.code == 1785)}
                                                onChange={(e) => this.typeaheadOnChange(executiveHr.name, e)}
                                                placeholder="Send to"
                                                isInvalid={executiveHr.error.length > 0}
                                            />
                                        </div>
                                    </React.Fragment>




                                    :
                                    <React.Fragment>
                                        <div className="col-6 col-md-4 my-2">
                                            <label>  Executive HR  </label>
                                        </div>


                                        <div className="col-6 col-md-8 my-2">
                                            <Typeahead
                                                id="ta-recipient"

                                                labelKey={(option) => `${option.name} - ${option.employeeNumber}`}
                                                name={executiveHr.name}
                                                value={executiveHr.value}
                                                multiple={false}
                                                options={executiveHr.options}
                                                onChange={(e) => this.typeaheadOnChange(executiveHr.name, e)}
                                                placeholder="Send to"
                                                isInvalid={executiveHr.error.length > 0}
                                            />
                                        </div>
                                    </React.Fragment>


                            }




                        </div>



                        <div className="row">
                            <div className="col-4 col-md-4 my-2">
                                <label>  Description   </label>
                            </div>

                            <div className="col-8 col-md-18 my-2">

                                <textarea
                                    type="text"
                                    rows={5}
                                    className={this.state.description.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                    // value={list[0].description}
                                    name={this.state.description.name}
                                    placeholder={list[0].description}
                                    value={this.state.description.value}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="col-4 col-md-4 my-2">

                            </div>

                        </div>





                        <div className="row">
                            <div className="col-6 col-md-6 my-2">
                                <button className="form-control"> cancel   </button>
                            </div>


                            <div className="col-6 col-md-6 my-2 ">

                                <button type="submit" className="btn btn-block submit-button btn-sm" onClick={this.updateMedical}> Submit </button>

                            </div>

                        </div>

                        <ToastContainer
                            position="top-right"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />



                    </React.Fragment> : ""


                }


            </React.Fragment>
        );
    }



    onChange = (e) => {

        const name = e.target.name;
        let value = e.target.value;

        onChange(this, name, value);

    }

    updateMedical = (e) => {
        e.preventDefault();
        const st = this.state

        const { list } = this.props
        let updateId = undefined
        list.find((ele) => updateId = ele.id)

        if (validateForm(this)) {

            let model = {
                updateId: updateId,
                consultationCharges: st.consultationCharges.value,
                medicineCost: st.medicineCost.value,
                pathologicalCharges: st.pathologicalCharges.value,
                physiothrapyCharges: st.physiothrapyCharges.value,
                operationCharges: st.operationCharges.value,
                operationTheatreCharges: st.operationTheatreCharges.value,
                anaesthesiaCharges: st.anaesthesiaCharges.value,
                roomIcuCharges: st.roomIcuCharges.value,
                injectionCharges: st.injectionCharges.value,
                disposalCharges: st.disposalCharges.value,
                dentalCharges: st.dentalCharges.value,
                otherCharges: st.otherCharges.value,
                totalSum: st.totalSum.value,
                description: st.description.value,
                pendingWith: st.ud.code == st.hrDealing.code ? st.hrExecutive.code
                    : st.ud.code == st.hrExecutive.code ? 1785 : "",
            }

            updateMedicalReport(model).then((res) => {
                if (res.status === constant.static.apiStatus.success) {
                    toast.info(' Updated ', {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    setTimeout(() => {
                        this.props.history.push(constant.component.medicalDesk.url)
                    }, 2000)

                } else {
                    alert(res.error);
                }
            })



        }



    }






}


export default withRouter(CommentModel)